import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { StackableRowVariantType } from '../../../../../components/stackableRow/types/stackableRowVariantType';
import { FONT_WEIGHT } from '../../foundations/typography';
import { TextVariantType } from '../variants';
export const getStackableRowStyles = (FOUNDATIONS, FONT) => {
    return {
        [StackableRowVariantType.DEFAULT]: {
            rootContainer: {
                display: 'flex',
                flex_direction: 'column',
                width: '100%',
                position: 'relative',
                gap: FOUNDATIONS.spacing_50,
                padding_bottom: FOUNDATIONS.spacing_250,
                padding_top: FOUNDATIONS.spacing_250,
                padding_right: FOUNDATIONS.spacing_150,
                background_color: FOUNDATIONS.color_neutral_bg_375,
                padding_left: `calc(${FOUNDATIONS.spacing_150} + ${FOUNDATIONS.spacing_150} + ${FOUNDATIONS.size_50})`,
                cursor: 'pointer',
                [DeviceBreakpointsType.DESKTOP]: {
                    flex_direction: 'row',
                    justify_content: 'space-between',
                },
                before: {
                    content: '',
                    display: 'block',
                    position: 'absolute',
                    width: FOUNDATIONS.size_50,
                    height: `calc(100% - ${FOUNDATIONS.spacing_250} - ${FOUNDATIONS.spacing_250})`,
                    background_color: FOUNDATIONS.color_chart_bg_50,
                    left: FOUNDATIONS.spacing_150,
                    border_radius: FOUNDATIONS.radius_1000,
                },
            },
            titleTagContainer: {
                display: 'flex',
                flex_direction: 'column',
                gap: FOUNDATIONS.spacing_50,
                align_items: 'flex-start',
                text_align: 'left',
                [DeviceBreakpointsType.DESKTOP]: {
                    margin_right: FOUNDATIONS.spacing_300,
                },
            },
            title: {
                font_variant: TextVariantType.FONT_PARAGRAPH_250,
                font_weight: FONT_WEIGHT.font_bold,
                color: FOUNDATIONS.color_neutral_font_50,
                text_decoration: 'underline',
            },
            description: {
                font_variant: TextVariantType.FONT_PARAGRAPH_200,
                font_weight: FONT_WEIGHT.font_regular,
                color: FOUNDATIONS.color_neutral_font_50,
            },
            container: {
                margin_top: FOUNDATIONS.spacing_200,
                display: 'flex',
                flex_direction: 'column',
                gap: FOUNDATIONS.spacing_150,
                width: '100%',
                [DeviceBreakpointsType.DESKTOP]: {
                    flex_direction: 'row',
                    margin_top: '0px',
                    width: 'auto',
                    align_items: 'flex-start',
                    gap: FOUNDATIONS.spacing_300,
                },
            },
            content: {
                display: 'flex',
                justify_content: 'space-between',
                width: '100%',
                text_align: 'left',
                [DeviceBreakpointsType.DESKTOP]: {
                    flex_direction: 'column',
                    width: FOUNDATIONS.size_975,
                    align_items: 'flex-start',
                    gap: FOUNDATIONS.spacing_100,
                },
            },
            contentLabel: {
                font_variant: TextVariantType.FONT_PARAGRAPH_350,
                font_weight: FONT_WEIGHT.font_regular,
                color: FOUNDATIONS.color_neutral_font_50,
            },
            contentValue: {
                font_variant: TextVariantType.FONT_PARAGRAPH_250,
                font_weight: FONT_WEIGHT.font_bold,
            },
        },
        [StackableRowVariantType.REGULAR]: {
            rootContainer: {
                display: 'flex',
                flex_direction: 'column',
                width: '100%',
                position: 'relative',
                gap: FOUNDATIONS.spacing_50,
                padding_bottom: FOUNDATIONS.spacing_250,
                padding_top: FOUNDATIONS.spacing_250,
                padding_right: FOUNDATIONS.spacing_150,
                background_color: FOUNDATIONS.color_neutral_bg_375,
                padding_left: `calc(${FOUNDATIONS.spacing_150} + ${FOUNDATIONS.spacing_150} + ${FOUNDATIONS.size_50})`,
                cursor: 'pointer',
                [DeviceBreakpointsType.DESKTOP]: {
                    flex_direction: 'row',
                    justify_content: 'space-between',
                },
                before: {
                    content: '',
                    display: 'block',
                    position: 'absolute',
                    width: FOUNDATIONS.size_50,
                    height: `calc(100% - ${FOUNDATIONS.spacing_250} - ${FOUNDATIONS.spacing_250})`,
                    background_color: FOUNDATIONS.color_chart_bg_50,
                    left: FOUNDATIONS.spacing_150,
                    border_radius: FOUNDATIONS.radius_1000,
                },
            },
            titleTagContainer: {
                display: 'flex',
                flex_direction: 'column',
                gap: FOUNDATIONS.spacing_50,
                align_items: 'flex-start',
                text_align: 'left',
                [DeviceBreakpointsType.DESKTOP]: {
                    margin_right: FOUNDATIONS.spacing_300,
                },
            },
            title: {
                font_variant: TextVariantType.FONT_PARAGRAPH_250,
                font_weight: FONT_WEIGHT.font_bold,
                color: FOUNDATIONS.color_neutral_font_50,
                text_decoration: 'underline',
            },
            description: {
                font_variant: TextVariantType.FONT_PARAGRAPH_200,
                font_weight: FONT_WEIGHT.font_regular,
                color: FOUNDATIONS.color_neutral_font_50,
            },
            container: {
                margin_top: FOUNDATIONS.spacing_200,
                display: 'flex',
                flex_direction: 'column',
                gap: FOUNDATIONS.spacing_150,
                width: '100%',
                [DeviceBreakpointsType.DESKTOP]: {
                    flex_direction: 'row',
                    margin_top: '0px',
                    width: 'auto',
                    align_items: 'flex-start',
                    gap: FOUNDATIONS.spacing_300,
                },
            },
            content: {
                display: 'flex',
                justify_content: 'space-between',
                width: '100%',
                text_align: 'left',
                [DeviceBreakpointsType.DESKTOP]: {
                    flex_direction: 'column',
                    width: FOUNDATIONS.size_975,
                    align_items: 'flex-start',
                    gap: FOUNDATIONS.spacing_100,
                },
            },
            contentLabel: {
                font_variant: TextVariantType.FONT_PARAGRAPH_350,
                font_weight: FONT_WEIGHT.font_regular,
                color: FOUNDATIONS.color_neutral_font_50,
            },
            contentValue: {
                font_variant: TextVariantType.FONT_PARAGRAPH_250,
                font_weight: FONT_WEIGHT.font_bold,
            },
        },
        [StackableRowVariantType.EMPTY]: {
            showEmptyText: true,
            rootContainer: {
                display: 'flex',
                flex_direction: 'column',
                width: '100%',
                position: 'relative',
                gap: FOUNDATIONS.spacing_50,
                padding_bottom: FOUNDATIONS.spacing_250,
                padding_top: FOUNDATIONS.spacing_250,
                padding_right: FOUNDATIONS.spacing_150,
                background_color: FOUNDATIONS.color_neutral_bg_375,
                padding_left: `calc(${FOUNDATIONS.spacing_150} + ${FOUNDATIONS.spacing_150} + ${FOUNDATIONS.size_50})`,
                cursor: 'pointer',
                [DeviceBreakpointsType.DESKTOP]: {
                    flex_direction: 'row',
                    justify_content: 'space-between',
                },
                before: {
                    content: '',
                    display: 'block',
                    position: 'absolute',
                    width: FOUNDATIONS.size_50,
                    height: `calc(100% - ${FOUNDATIONS.spacing_250} - ${FOUNDATIONS.spacing_250})`,
                    background_color: FOUNDATIONS.color_chart_bg_50,
                    left: FOUNDATIONS.spacing_150,
                    border_radius: FOUNDATIONS.radius_1000,
                },
            },
            title: {
                font_variant: TextVariantType.FONT_PARAGRAPH_250,
                font_weight: FONT_WEIGHT.font_bold,
                color: FOUNDATIONS.color_neutral_font_50,
                text_decoration: 'underline',
            },
            description: {
                font_variant: TextVariantType.FONT_PARAGRAPH_200,
                font_weight: FONT_WEIGHT.font_regular,
                color: FOUNDATIONS.color_neutral_font_50,
            },
            container: {
                margin_top: FOUNDATIONS.spacing_200,
                display: 'flex',
                flex_direction: 'column',
                gap: FOUNDATIONS.spacing_150,
                width: '100%',
                [DeviceBreakpointsType.DESKTOP]: {
                    flex_direction: 'row',
                    margin_top: '0px',
                    width: 'auto',
                    align_items: 'flex-start',
                    align_self: 'center',
                },
            },
            titleTagContainer: {
                display: 'flex',
                flex_direction: 'column',
                gap: FOUNDATIONS.spacing_50,
                align_items: 'flex-start',
                text_align: 'left',
                [DeviceBreakpointsType.DESKTOP]: {
                    margin_right: FOUNDATIONS.spacing_300,
                },
            },
            emptyTextContainer: {
                text_align: 'left',
            },
            emptyText: {
                font_variant: TextVariantType.FONT_PARAGRAPH_350,
                font_weight: FONT_WEIGHT.font_regular,
                color: FOUNDATIONS.color_neutral_font_50,
            },
        },
    };
};
//# sourceMappingURL=styles.js.map